import SelfConfirm from "./selfconfirm.vue"
import SelfError from "./selferror.vue"

import Vue from "vue";
import VueI18n from 'vue-i18n'
import zh from '../../../assets/js/i18n/langs/zh.js'
import en from '../../../assets/js/i18n/langs/en.js'

//使用引入
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale : localStorage.getItem('lang') || 'zh', // 语言
  messages: {  // 文案
  zh, // 文案的中文版
  en // 文案的英文版
  }
})

function install(Vue) {
  Object.defineProperty(Vue.prototype, '$selfConfirm', {
    get() {
      var div = document.createElement('div')
      document.body.appendChild(div);
      return (opt) => {
        const Constructor = Vue.extend(SelfConfirm)
        var Instance = new Constructor({
          data() {
            return {
              content: opt.content ? opt.content : i18n.t('pub.issureOperation')+"?",
              title: opt.title ? opt.title : i18n.t('production.directorList.opSure'),
              okText: opt.okText ? opt.okText : i18n.t('pub.queren'),
              cancelText: opt.cancelText ? opt.cancelText : i18n.t('pub.cancel'),
              okCallback: opt.okCallback ? opt.okCallback : function () {},
              cancelCallback: opt.cancelCallback ? opt.cancelCallback : function () {},
              show: true,
              flag: opt.flag == 1 ? false : true,
            }
          }
        }).$mount(div);
      }
    }
  });

  Object.defineProperty(Vue.prototype, '$selfError', {
    get() {
      var div = document.createElement('div')
      document.body.appendChild(div);
      return (opt) => {
        const Constructor = Vue.extend(SelfError)
        var Instance = new Constructor({
          data() {
            var content
            // if (opt.errcode) {
            //   content = Util.getErrorMessage(opt.errcode, opt.content);
            // } else {
            //   content = opt.content;
            // }
            if (opt.content) {
              content = opt.content;
            } else {
              content = Util.getErrorMessage(opt.errcode, opt.content);
            }
            return {
              content: content,
              title: opt.title ? opt.title : i18n.t('pub.error'),
              okText: opt.okText ? opt.okText : i18n.t('pub.sure'),
              show: true,
              closeCallback: opt.closeCallback ? opt.closeCallback : function () {},
            }
          }
        }).$mount(div);
      }
    }
  });
}

export default install



// WEBPACK FOOTER //
// ./src/views/live/common/index.js